export class IController {
  constructor(nameClass){
    this.setNewNode = () => { throw errorMsg( nameClass, 'setNewNode()') }
    this.loadNode = () => { throw errorMsg( nameClass, 'loadNode()') }
    this.saveNodes = () => { throw errorMsg( nameClass, 'saveNodes()') }
    this.removeNode = () => { throw errorMsg( nameClass, 'removeNode()') }
    this.addNode = () => { throw errorMsg( nameClass, 'addNode()') }
    this.updateNode = () => { throw errorMsg( nameClass, 'updateNode()') }
    this.getProperties = () => { throw errorMsg( nameClass, 'getProperties()') }
    this.getNode = () => { throw errorMsg( nameClass, 'getNode()') }
  }
}

function errorMsg(nameClass, nameMethod){
  return `ATENÇÃO! - Implementar método ${nameMethod} na classe ${nameClass}`
}